import { apiService } from './api-service';

// Interface for invite user request

export interface UserSettings {
  theme: string,
  language: string,
  timezone: string,
  showEmail: boolean,
  defaultGame: string,
  showLastLogin: boolean,
  projectUpdates: boolean,
  marketingEmails: boolean,
  twoFactorEnabled: boolean,
  profileVisibility: string,
  pushNotifications: boolean,
  emailNotifications: boolean,
}
export interface InviteUserRequest {
  email: string;
  settings: UserSettings;
  role: string;
  companyId: string;
  gameIds?: string[];
}

// Interface for invite user response
export interface InviteUserResponse {
  success: boolean;
  data?: {
    invitation_code: string;
    code_id: string;
    email: string;
    role: string;
    company_name: string;
    games_count: number;
    expires_at?: string;
    user_existed?: boolean;
    email_sent?: boolean;
    warning?: string;
  };
  error?: string;
  message: string;
}

class LocanestApiService {
  /**
   * Lookup a user by email to check if they exist in LocaNest
   */
  async lookupUserByEmail(email: string): Promise<{
    success: boolean;
    exists: boolean;
    user?: {
      id: string;
      email: string;
      username: string;
      full_name: string;
    };
    error?: string;
  }> {
    try {
      const response = await apiService.lookupUserByEmail(email);
      console.log('Lookup user by email response:', response);
      return {
        success: response.success,
        exists: response.data?.exists || false,
        user: response.data?.user,
        error: response.error
      };
    } catch (error) {
      console.error('Error looking up user:', error);
      return {
        success: false,
        exists: false,
        error: 'Network error'
      };
    }
  }

  /**
   * Invite a user to join a company
   */
  async inviteUser(request: InviteUserRequest): Promise<InviteUserResponse> {
    try {
      const response = await apiService.inviteUser({
        email: request.email,
        role: request.role,
        companyId: request.companyId,
        gameIds: request.gameIds
      });

      return {
        success: response.success,
        data: response.data,
        error: response.error,
        message: response.success ? `Invitation code created: ${response.data?.invitation_code}` : response.error || 'Failed to invite user'
      };
    } catch (error) {
      console.error('Error inviting user:', error);
      return {
        success: false,
        error: 'Network error',
        message: 'Failed to invite user due to network error'
      };
    }
  }
}

export const locanestApiService = new LocanestApiService();
